import ErrorModel from '../models/error'
import { defaults } from 'underscore'

export default async function (model, options = {}) {
  const opts = {
    data: defaults(options, {
      include: 'poll_instances'
    })
  }

  try {
    await model.fetch(opts)
    return model
  } catch (xhr) {
    return new ErrorModel({ code: xhr.status, xhr })
  }
}
